import { render, staticRenderFns } from "./AditamentoButton.vue?vue&type=template&id=6bcdaeed&scoped=true&"
import script from "./AditamentoButton.vue?vue&type=script&lang=js&"
export * from "./AditamentoButton.vue?vue&type=script&lang=js&"
import style0 from "./AditamentoButton.vue?vue&type=style&index=0&id=6bcdaeed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdaeed",
  null
  
)

export default component.exports